import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, retry } from 'rxjs';
import { Global } from '../global/globalApi';
import { LAYOUT_ID, COMPONENT_NAME, ALIS_FIELD_KEY, TBA_LOGIN_URL } from '../models/Constants';
import { TbaRegistrationDTO } from '../models/TbaRegistrationDTO';
import { NewAgentApiService } from './new-agent-api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../../app/models/Constants';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { AwsSqsService } from './aws-sqs.service';


@Injectable({
  providedIn: 'root',
})
export class DashboardBusinessLogicService {

  constructor(
    private apiService: NewAgentApiService,
    private http: HttpClient,
    private encrytDecryptService: EncryptDecryptService,
    public awsSQSService: AwsSqsService,
    private rootScopeService: RootScopeService
  ) { }


  /*Below method return the Data of ALIS regions.**/
  getALISRegionsList(): Observable<any> {
    let url = `${Global.domainUrl + Global.dashboardApi.ALISRegionsUrl
      }?validFieldKey=${ALIS_FIELD_KEY}`;
    return this.http
      .get(url, {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
      })
      .pipe(
        map((res: any) =>
          res?.data?.body.map((regions: any) => {
            return {
              region: regions.fieldValue,
              displayName: regions.fieldValueDescription,
            };
          })
        )
      );
  }
  /* Below savePreferenceValue method save the preference value of pref_region in database */
  savePreferenceValue(): Observable<any> {
    let lanId: any = sessionStorage.getItem('lanId');
    let pref_region: any = sessionStorage.getItem('pref_region');
    let payload = {
      lan_id: lanId,
      pref_region: pref_region,
    };
    return this.http.post(
      Global.domainUrl + Global.dashboardApi.SAVE_PREFERENCE_VALUE,
      payload,
      {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }
    );
  }

  tbaGuiRegistration(reqBody: TbaRegistrationDTO): Observable<any> {
    // console.log('Method tbaGuiRegistration called');
    let url = Global.domainUrl + Global.TBA_GUI_REGISTER_API;
    // console.log('tbaGuiRegistration url', url);
    return this.http.post(url, reqBody, {
      headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
      responseType: 'text',
    });
  }

  /**Below method fetch the TBA GUI WebFront and data contain the TBA GUI port number and also the
  * TBA GUI session and on the successful response we change the TBA indicator to green and start the
  * startTbaConnectivityInterval() method and in case of an error we change the TBA indicator to red .*/

  getTBAGUIWebFrontData() {
    const lanId: string = sessionStorage.getItem('lanId')!;
    const payload = {
      username: lanId,
    };
    const url = `${Global.domainUrl}${Global.TBA_GUI_GET_DATA_API}`;
    return this.http
      .post(url, payload, {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }).pipe(retry({ count: 3, delay: 5000 }),)
      .subscribe({
        next: (res: any) => {
          const data = JSON.parse(res);
          if (data && data?.data?.port) {
            sessionStorage.setItem('tba_port', data?.data?.port);
            sessionStorage.setItem('tba_sessionId', data?.data?.sessionId);
            this.loginTBAGUIApp();
          }
          // this.rootScopeService.tbaIndicatorClass.next(
          //   Constants.TBA_INDICATOR_COLOR.GREEN
          // );
          // this.rootScopeService.TBAGUIHealthCheckError = false;
          // this.rootScopeService.TBAGUIConnected = true;

          this.startTbaConnectivityInterval();
        },
        error: (err: any) => {
          //this.launchTBAGUIApp();
          this.rootScopeService.tbaIndicatorClass.next(
            Constants.TBA_INDICATOR_COLOR.RED
          );
          // console.log(err);
          this.rootScopeService.TBAGUIHealthCheckError = true;
          this.rootScopeService.TBAGUIConnected = false;
          console.log('isLogEnabledUser---->'+this.rootScopeService.isLogEnabledUser);
          this.rootScopeService.captureLogsDb("TBAGUI-GET-API-FAILURE: "+err?.error,Constants.ERROR);
          },
      });
  }

  /**Below method open the TBAGUIApp when authentication success
     */
  launchTBAGUIApp() {
    this.rootScopeService.openNewTab(TBA_LOGIN_URL);
  }

  /**Below method check the TBA GUI health on hitting the localhost url on which contain TBA GUI port and
   * TBA GUI session and if its gets successful response the TBA indicator turns into green and in case of any error
   * the TBA indicator turns into red.*/
  getTbaHealthConnectivity() {
    // console.log('getTbaHealthConnectivity callled')
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/health/${sessionId}`;
    this.http.get(url).subscribe({
      next: (res: any) => {
        //  console.log('health :' + JSON.stringify(res));
        this.rootScopeService.tbaIndicatorClass.next(
          Constants.TBA_INDICATOR_COLOR.GREEN
        );
        this.rootScopeService.TBAGUIHealthCheckError = false;
        this.rootScopeService.TBAGUIConnected = true;

      },
      error: (err: any) => {
        this.rootScopeService.tbaIndicatorClass.next(
          Constants.TBA_INDICATOR_COLOR.RED
        );
        this.rootScopeService.TBAGUIHealthCheckError = true;
        this.rootScopeService.TBAGUIConnected = false;
        //this.rootScopeService.captureLogsDb("TBAGUI-HEALTH-CONNECT-API-FAILURE: "+err?.error,Constants.ERROR);
        },
    });
  }


  /**Below method start the setInterval exposed method which we implemented for 
   * TBA GUI health check in every 60 seconds(db-configurable in mili seconds).*/
  startTbaConnectivityInterval() {
    this.getTbaHealthConnectivity();
    // console.log('startTbaConnectivityInterval called');
    const intervalTime = 1 * this.rootScopeService.tbaConnectivityThreshold;
    this.rootScopeService.tbaConnectivitySetInterval = setInterval(() => {
      this.getTbaHealthConnectivity();
    }, intervalTime);
  }

  /**Below method clear the setInterval exposed method which we started for 
   * TBA GUI health check in every 60 seconds(db-configurable).*/
  stopTbaConnectivityInterval() {
    clearInterval(this.rootScopeService.tbaConnectivitySetInterval);
  }
  /*Below method loginTBAGUIApp() login the TBAGUIWEBFRONT App by recfId and Password**/
  loginTBAGUIApp() {
    // console.log('Method loginTBAGUIApp called');
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = `https://localhost:${port}/login`;
    //let tbaGuiRegisterFormObj = this.rootScopeService.getValueFromSessiondb("tbaGuiRegisterFormObj", TbaRegistrationDTO)
    // let decryptRecfId = this.encrytDecryptService.decrypt(tbaGuiRegisterFormObj?.racfId);
    // let decryptRacfPassword = this.encrytDecryptService.decrypt(tbaGuiRegisterFormObj?.racfPassword);
    let payload = {
      racfId: this.rootScopeService.tbaGuiRegisterFormObj.racfId ? this.rootScopeService.tbaGuiRegisterFormObj.racfId : '@TBUD01',
      password: this.rootScopeService.tbaGuiRegisterFormObj.racfPassword ? this.rootScopeService.tbaGuiRegisterFormObj.racfPassword : '',
      sessionId: sessionId
    };
    // console.log('loginTBA url', url);
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json');
    this.http.post(url, payload, {
      headers: headers,
      responseType: 'text',
    }).subscribe({
      next: (data: any) => {
        if (data?.result == 'success' || JSON.parse(data).result) {
          this.rootScopeService.TBAGUIAuthenticated = true;
          this.closeTBAWebFrontTab();
          // console.log('loginTBAGUIApp success', data?.result);
        }
      },
      error: (error) => {
        this.rootScopeService.TBAGUIAuthenticated = false;
        // console.log('Error in loginTBAGUIApp', error);
        this.rootScopeService.captureLogsDb("TBAGUI-LOGIN-API-FAILURE: "+error,Constants.ERROR);
      },
    });
  }

  closeTBAWebFrontTab(){
    if (this.rootScopeService.tbawindow.has(this.rootScopeService.sessionId)) {
      let tabRef = this.rootScopeService.tbawindow.get(this.rootScopeService.sessionId);
      if (tabRef)
        tabRef?.close();
    }
  }
}
